import { IGlobalState } from '../../../Root/store/appReducer'

export const getAuthData = (state: IGlobalState) => state.auth.userDto
export const getUserCompanies = (state: IGlobalState) => state.auth.userCompanies
